export default __webpack_public_path__ + "static/media/Srushti Pharma Logo.370ccee3.jpg";